import React from 'react';
import {useDocumentTitle} from '../hooks/useDocumentTitle';

const NotFound: React.FC = () => {
    useDocumentTitle('Страница не найдена');

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
            <div className="text-center">
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-primary-600 mb-4">404</h1>
                    <h2 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
                        Страница не найдена
                    </h2>
                    <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
                        К сожалению, запрашиваемая страница не существует
                    </p>
                </div>

                <div className="mb-8">
                    <img
                        src="/cat.jpeg"
                        alt="cat"
                        className="max-w-xs w-full rounded-xl shadow-lg mx-auto"
                    />
                </div>

                <button
                    onClick={() => window.history.back()}
                    className="btn-primary px-8 py-3 text-base"
                >
                    Вернуться назад
                </button>
            </div>
        </div>
    );
};

export default NotFound;
